<template>
  <VButton v-bind="$attrs" :loading="isPending">
    <IconLoad v-if="isPending" class="preloader" />
    <template v-else>
      <slot></slot>
    </template>
  </VButton>
</template>

<script>
import VButton from "@/components/ui/VButton";
import IconLoad from "@/components/icons/IconLoad";

export default {
  name: "AsyncButton",
  components: { VButton, IconLoad },
  props: {
    isPending: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.preloader {
  position: relative;
  z-index: 1;
  width: 16px;
  height: 16px;

  animation: 3s linear infinite rotate;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}
</style>
